import { render, staticRenderFns } from "./AssetCategoryView.vue?vue&type=template&id=5b757006&"
import script from "./AssetCategoryView.vue?vue&type=script&lang=js&"
export * from "./AssetCategoryView.vue?vue&type=script&lang=js&"
import style0 from "./AssetCategoryView.vue?vue&type=style&index=0&id=5b757006&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports